export enum ApprovableTxnType {
  ChargeCodeRequest = "ChargeCodeRequest",
  LeaveRequest = "LeaveRequest",
  TrainingRequest = "TrainingRequest",
  VacationRequest = "VacationRequest",

  // manager self service transactions
  DepartmentChange = "DepartmentChange",
  LocationChange = "LocationChange",
  PositionChange = "PositionChange",
  SalaryChange = "SalaryChange",
  StatusChange = "StatusChange",

  // recruit to hire
  JobRequisition = "JobRequisition",
  JobCandidateInterview = "JobCandidateInterview",
  NewHireRequest = "NewHireRequest",
  NewHireOfferLetter = "NewHireOfferLetter",

  // finance and procurement transactions
  ExpenseReport = "ExpenseReport",
  PurchaseRequisition = "PurchaseRequisition",
  SalesOrder = "SalesOrder",
  PurchaseOrder = "PurchaseOrder",
  VendorInvoice = "VendorInvoice",
  CustomerInvoice = "CustomerInvoice",
  Return = "Return",
  MaterialOrder = "MaterialOrder",
  BillOfMaterial = "BillOfMaterial",

  // contract or project transactions
  Contract = "Contract",
  ContractMod = "ContractMod",
  ContractBid = "ContractBid",
  Project = "Project",
  ProjectEstimate = "ProjectEstimate",

  // vendor or customer partner
  Vendor = "Vendor",
  Customer = "Customer"
}


export enum Transaction {

  All = 'ALL',

  // employee self service transactions
  ChargeCodeRequest = "ESS_CHARGE_CODE_REQUEST",
  LeaveRequest = "ESS_LEAVE_REQUEST",
  TrainingRequest = "ESS_TRAINING_REQUEST",
  VacationRequest = "ESS_VACATION_REQUEST",
  QleRequest = "ESS_QLE_REQUEST",


  // manager self service transactions
  DepartmentChange = "MSS_DEPARTMENT_CHANGE",
  LocationChange = "MSS_LOCATION_CHANGE",
  PositionChange = "MSS_POSITION_CHANGE",
  SalaryChange = "MSS_SALARY_CHANGE",
  StatusChange = "MSS_STATUS_CHANGE",

  // organization documents
  OrgPolicy = "ORG_POLICY",
  OrgDocument = "ORG_DOCUMENT",
  OrgPayRollTax = "ORG_PAYROLL_TAX",
  BenefitProviderPlan = "BENEFIT_PROVIDER_PLAN",
  BenefitProvider = "BENEFIT_PROVIDER",
  Compliance = "COMPLIANCE",
  OrgFile = "ORG_FILE",

  //Ach Controller and Beneficial Owner
  OrgController = "ORG_CONTROLLER",
  OrgBeneficialOwner = "ORG_BENEFICIAL_OWNER",

  // recruit to hire
  JobRequisition = "JOB_REQUISITION",
  JobCandidateInterview = "JOB_CANDIDATE_INTERVIEW",
  NewHireRequest = "NEW_HIRE_REQUEST",
  NewHireOfferLetter = "NEW_HIRE_OFFER_LETTER",
  OnboardingDocumentAck = "ONBOARDING_DOCUMENT_ACK",
  OnboardingPolicyAck = "ONBOARDING_POLICY_ACK",
  EmployeeProvisioning = "EMPLOYEE_PROVISIONING",
  EmploymentApplication = "EMPLOYMENT_APPLICATION",
  EmployeeDeprovisioning = "EMPLOYEE_DEPROVISIONING",

  // finance and procurement transactions
  ExpenseReport = "EXPENSE_REPORT",
  Timesheet = "TIMESHEET",
  UserActivityReport = "USER_ACTIVITY_REPORT",

  PurchaseRequisition = "PURCHASE_REQUISITION",
  BillOfMaterial = "BILL_OF_MATERIAL",
  PurchaseOrder = "PURCHASE_ORDER",
  Receipt = "RECEIPT",
  PurchaseReturn = "PURCHASE_RETURN",
  VendorInvoice = "VENDOR_INVOICE",
  VendorPayment = "VENDOR_PAYMENT",

  SalesOrder = "SALES_ORDER",
  MaterialOrder = "MATERIAL_ORDER",
  PackingSlip = "PACKING_SLIP",
  SalesReturn = "SALES_RETURN",
  CustomerInvoice = "CUSTOMER_INVOICE",
  ManualCustomerInvoice = "MANUAL_CUSTOMER_INVOICE", // Not present in txn_type, Backend equivalent is CUSTOMER_INVOICE
  AdvancedShippingNotice = "ADVANCED_SHIPPING_NOTICE",

  // contract or project transactions
  Contract = "CONTRACT",
  ContractMod = "CONTRACT_MODIFICATION",
  ContractBid = "CONTRACT_BID",
  Project = "PROJECT",
  ProjectMod = "PROJECT_MODIFICATION",
  ProjectEstimate = "PROJECT_ESTIMATE",
  ProjectModification = "PROJECT_MODIFICATION",
  AtRiskRequest = "AT_RISK_REQUEST",

  // vendor or customer partner
  Vendor = "VENDOR",
  Customer = "CUSTOMER",

  PayrollPayment = "PAYROLL_PAYMENT",

  JournalEntry = "JOURNAL_ENTRY",
  RateChange = "RATE_CHANGE",

  // for Dashboard
  BusinessIntelligence = "BI",
  Storage = "STORAGE",

  EssUser = "ESS_USER",

  SupportFile = "SUPPORT_FILE",
  SecurityControlAssessment = "SECURITY_CONTROL_ASSESSMENT",
  SecurityPolicy = "SECURITY_POLICY"

}

export enum RetirementContributionType {
  Regular = "REGULAR",
  Catchup = "CATCHUP"
}

// benifit summary
export enum DeductionType {
  HealthMedical = "HEALTH_MEDICAL",
  HealthVision = "HEALTH_VISION",
  HealthDental = "HEALTH_DENTAL",
  Combined125 = "COMBINED_125_PLAN",
  SpendingCSA = "SPENDING_CSA",
  SpendingDependentFSA= "SPENDING_DEPENDENT_FSA",
  SpendingFSA = "SPENDING_FSA",
  SpendingHSA = "SPENDING_HSA",
  InsuranceStdVoluntary = "INSURANCE_STD_VOLUNTARY",
  InsuranceLtdVoluntary = "INSURANCE_LTD_VOLUNTARY",
  InsuranceAccidentalVoluntary = "INSURANCE_ACCIDENTAL_VOLUNTARY",
  InsuranceLifeVoluntary = "INSURANCE_LIFE_VOLUNTARY",
  InsuranceAccidentalInvoluntary = "INSURANCE_ACCIDENTAL_INVOLUNTARY",
  InsuranceLifeInvoluntary = "INSURANCE_LIFE_INVOLUNTARY",
  InsuranceStdInvoluntary = "INSURANCE_STD_INVOLUNTARY",
  InsuranceLtdInvoluntary = "INSURANCE_LTD_INVOLUNTARY",
  Retirement125 = "RETIREMENT_125",
  Retirement401K = "RETIREMENT_401K",
  Retirement401KCatchUp= "RETIREMENT_401K_CATCH_UP",
  Retirement403B = "RETIREMENT_403B",
  Retirement403BCatchUp = "RETIREMENT_403B_CATCH_UP",
  Retirement457 = "RETIREMENT_457",
  RetirementRoth401K = "RETIREMENT_ROTH_401K",
  RetirementRoth403B = "RETIREMENT_ROTH_403B",
  RetirementRoth457 = "RETIREMENT_ROTH_457",
  RetirementSimpleIRA = "RETIREMENT_SIMPLE_IRA",


}
export namespace DeductionType {
  export function is401kRetirementType(deductionType: DeductionType){
    return deductionType == DeductionType.Retirement401K || deductionType == DeductionType.Retirement401KCatchUp;
  }

  export function isDeductionPercentageApplicable(deductionType: DeductionType){
    return isRetirementType(deductionType);
  }

  export function isRothRetirementType(deductionType: DeductionType){
    return deductionType == DeductionType.RetirementRoth401K || deductionType == DeductionType.RetirementRoth403B
      || deductionType == DeductionType.RetirementRoth457;
  }
  export function requireDeductionMethodType(deductionType: DeductionType){
    return isRetirementType(deductionType);
  }
  export function isRetirementType(deductionType: DeductionType){
    return is401kRetirementType(deductionType) || isRothRetirementType(deductionType)
      || deductionType == DeductionType.Retirement125 || deductionType == DeductionType.Retirement457 || deductionType == DeductionType.Retirement403B;
  }

  export function isPreTaxRetirementType (deductionType: DeductionType) {
    return is401kRetirementType(deductionType) || deductionType == DeductionType.Retirement403B
      || deductionType == DeductionType.RetirementSimpleIRA || deductionType == DeductionType.Retirement403BCatchUp ;
  }
  export function isPostTaxRetirementType (deductionType: DeductionType) {
    return isRothRetirementType(deductionType);
  }
  export function isOtherRetirementType (deductionType: DeductionType) {
    return deductionType == DeductionType.Combined125;
  }

  export function isHealthPlan(deductionType: DeductionType): boolean {
    return deductionType == DeductionType.HealthVision || deductionType == DeductionType.HealthDental || deductionType == DeductionType.HealthMedical;
  }
  export function isInVoluntaryPlan(deductionType: DeductionType): boolean {
    return deductionType == DeductionType.InsuranceLifeInvoluntary || deductionType == DeductionType.InsuranceLtdInvoluntary
      || deductionType == DeductionType.InsuranceStdInvoluntary || deductionType == DeductionType.InsuranceAccidentalInvoluntary;
  }

  export function isSpendingPlan(deductionType: DeductionType): boolean {
    return deductionType == DeductionType.SpendingCSA || deductionType == DeductionType.SpendingHSA
      || deductionType == DeductionType.SpendingFSA || deductionType == DeductionType.SpendingDependentFSA
  }
}

export enum HealthCoverageType {
  NoSelection = "NO_SELECTION",
  Employee = "EMPLOYEE",
  EmployeePlusSpouse = "EMPLOYEE_PLUS_SPOUSE",
  EmployeePlusChild = "EMPLOYEE_PLUS_CHILD",
  Family = "FAMILY"
}

export enum BenefitPremiumType {
  PerEmployee =  "PER_EMPLOYEE",
  PerAge = "PER_AGE",
  PerGroup = "PER_GROUP"
}

export enum DeductionMethodType {
  FixedDollarAmount = "FIXED_DOLLAR_AMOUNT",
  GrossPayPercentage = "GROSS_PAY_PERCENTAGE",
}


export enum Plan {
  Health = "HEALTH",
  Insurance = "INSURANCE",
  Retirement = "RETIREMENT",
  Spending = "SPENDING",
}

export enum PayrollType {
  Regular = "REGULAR",
  Special = "SPECIAL",
  Calculator = "CALCULATOR",
}

export enum PaymentTxnType {
  VoucherRegister = "VOUCHER_REGISTER",
  Payroll = "PAYROLL",
  OrgInvoice = "ORG_INVOICE"
}

export enum VoucherRegisterTxnType {
  VendorInvoice = "VENDOR_INVOICE",
  ExpenseReport = "EXPENSE_REPORT"
}
